const shouldBeADarkColor = (bgColor: string): boolean => {
  return parseInt(bgColor.replace("#", ""), 16) > 0xffffff / 2;
};

export default shouldBeADarkColor;
